import React from "react";

const UserInfo = ({ name, status, financialStatus, classes }) => {
  return (
    <div className={classes.userInfo}>
      <span className={classes.userName}>{name}</span>
      {financialStatus && (
        <span className={classes.userFinancialStatus}>{financialStatus}</span>
      )}
      {status && <span className={classes.userStatus}>{status}</span>}
    </div>
  );
};

export default UserInfo;
